import React from 'react';
import { motion } from 'framer-motion';
interface CookieBannerProps {
  onAcceptAll: () => void;
  onCustomize: () => void;
}
export const CookieBanner = ({
  onAcceptAll,
  onCustomize
}: CookieBannerProps) => {
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} exit={{
    y: 100,
    opacity: 0
  }} transition={{
    duration: 0.3
  }} className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-lg z-50" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-15">
        <div className="text-sm text-gray-600 text-center sm:text-left" data-id="element-16">
          We use cookies to enhance your experience. By continuing to visit this
          site you agree to our use of cookies.{' '}
          <button onClick={onCustomize} className="text-[#8679DF] hover:text-[#7668CE] underline" data-id="element-17">
            Customize preferences
          </button>
        </div>
        <div className="flex gap-4" data-id="element-18">
          <button onClick={onCustomize} className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900" data-id="element-19">
            Customize
          </button>
          <button onClick={onAcceptAll} className="bg-[#8679DF] text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-[#7668CE] transition-colors" data-id="element-20">
            Accept All
          </button>
        </div>
      </div>
    </motion.div>;
};